// 导入单个组件
import Vue from "vue";
import Router from '../router'
 
const commons = { 
    Skip(routerName) {

        Router.push({
            name: routerName, 
        });
    }
};
export default commons;

// WEBPACK FOOTER //
// ./src/common/axios.js
